import { render, staticRenderFns } from "./SideNavMini.vue?vue&type=template&id=6e3a44b0&scoped=true"
import script from "./SideNavMini.vue?vue&type=script&lang=js"
export * from "./SideNavMini.vue?vue&type=script&lang=js"
import style0 from "./SideNavMini.vue?vue&type=style&index=0&id=6e3a44b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e3a44b0",
  null
  
)

export default component.exports